import React, {Component} from "react";
import {Col, Table} from "reactstrap";
import {Calculator} from "./Calculator";
import PropTypes from "prop-types";
import {Strings} from "./Strings";

class Result extends Component {
    render() {
        return <tr>
            <td className={this.props.first && "tableFirst"}>{this.props.name}:</td>
            <td className={"tableResult " + (this.props.first ? "tableFirst" : "")}>{this.props.result || "N/A"}</td>
            <td className={this.props.first && "tableFirst"}> [{this.props.unit}]</td>
        </tr>;
    }
}

Result.propTypes = {
    name: PropTypes.string,
    result: PropTypes.node,
    unit: PropTypes.string
};

export class CalculationBlock extends Component {
    render() {
        const pressureDifference = Math.round(Calculator.calcPressureDifference(this.props.inputData)*100)/100;
        const flowVelocity = Calculator.calcFlowVelocity(this.props.inputData);
        const valveKv = Calculator.calcValveKvValue(this.props.inputData);
        const minFlow = Calculator.calcMinRecomendedFlow(this.props.inputData);
        const maxFlow = Calculator.calcMaxRecomendedFlow(this.props.inputData);
        const calcedKv = Calculator.calcCalcedKvValue(this.props.inputData);
        
        return <Col><h2>{Strings.titleCalculationBlock}</h2>
            <div className="block botSpace">
                <Table>
                    <tbody>
                    <Result name={Strings.calculationPressureDifference} unit={Strings.unitPressure}
                            result={pressureDifference} first/>
                    <Result name={Strings.calculationFlowVelocity} unit={Strings.unitVelocity}
                            result={flowVelocity}/>
                    <Result name={Strings.calculationValveKv} unit={Strings.unitKv}
                            result={valveKv}/>
                    <Result name={Strings.calculationMinFlow} unit={Strings.unitFlow}
                            result={minFlow}/>
                    <Result name={Strings.calculationMaxFlow} unit={Strings.unitFlow}
                            result={maxFlow}/>
                    <Result name={Strings.calculationCalcedKv} unit={Strings.unitKv}
                            result={calcedKv}/>
                    </tbody>
                </Table>
            </div>
        </Col>;
    }
}

CalculationBlock.propTypes = {
    inputData: PropTypes.shape({
        flow: PropTypes.number,
        inletPressure: PropTypes.number,
        outletPressure: PropTypes.number,
        valveDimension: PropTypes.number,
        valveBore: PropTypes.number,
        description: PropTypes.string
    }).isRequired
};